import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';
import { STATE_CHANGES_FIELD } from '@utils/reusableGraphQLFields';

export const FETCH_TRANSFERS_QUERY = (
  permissions: string[],
) => `query fetchTransfers($input: FetchTransfersInput!) {
  fetchTransfers(input: $input) {
    transfers {
      id
      amountCents
      initiatedByRepresentative
      state
      type
      source
      sourceId
      ${STATE_CHANGES_FIELD}
      instantInvest
      dividendFor {
        ticker
      }
      fromSubAccount {
        id
        account {
          type
        }
      }
      failReason
      cancelReason
      cancelReconciledReason
      bankAccount {
        id
        name
        institutionNumber
        bankAccountNumber
        transitNumber
        ${permissions.includes('read:bank_account_disclosed') ? 'transitNumberDisclosed' : ''}
        ${permissions.includes('read:bank_account_disclosed') ? 'bankAccountNumberDisclosed' : ''}
      }
      isWithdrawAll
      ${permissions.includes('read:alert_report_basic') ? 'isSuspicious' : ''}
      ${
        permissions.includes('write:alert_report_basic')
          ? `
        alertReport {
          id
          rules {
            type
            translatedDescription { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      `
          : ''
      }
      subAccount {
        id
        account {
          id
          type
          user {
            id
            type
            entityName
            ${permissions.includes('read:client_low_risk_pii') ? 'firstName middleName lastName' : ''}
          }
          organization {
            id
          }
        }
        goal {
          name
        }
        financialProduct {
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        statistics {
          marketValueCents
          moneyAvailableCents
          availableFundsToWithdrawCents
        }
      }
      createdAt
      reconciledAt
      isRecurring
      manualProcess {
        id
        type
        signedUrl
        institution { name }
        transferAccount
        transferAccountNumber
        transferMethod
      }
      fiscalDate
      usaContributionType
      usaWithdrawalReason
    }
    totalCount
  }
}`;

export const FETCH_TRANSFERS = (permissions: string[]) =>
  gql`${FETCH_TRANSFERS_QUERY(permissions)}`;
